import { ApiError } from './api-error';


/** Первое сообщение из значения поля ошибки: строка либо массив строк. */
export function firstMessage (value: unknown): string | undefined {
    if (typeof value === 'string') return value;
    if (Array.isArray(value) && typeof value[0] === 'string') return value[0];

    return undefined;
}

/**
 * BFF заворачивает ответ бэкенда в `{ error, originalError: { status, data } }`.
 * Возвращает `data` оригинальной ошибки (например `{ detail: 'team_full' }`) либо пустой объект.
 */
export function getBackendErrorData (err: unknown): Record<string, unknown> {
    if (!(err instanceof ApiError) || !err.data || typeof err.data !== 'object') return {};

    const original = (err.data as { originalError?: { data?: unknown } }).originalError?.data;

    return original && typeof original === 'object' ? original as Record<string, unknown> : {};
}
